import React, { useCallback } from 'react';
import { Translate, TranslateScope, useTranslate } from '@pegasus/translation';
import { Size, MessageDialog } from '@lux/dialog';
import { Notification as NotificationPermissionIcon } from '@lux/graphics';
import { TRACK_EVENTS } from '../types';
import { TextWrapper } from './styles';
export function PermissionDialog({ isShown, firstName, data, onRegister, onClose, onTrack, }) {
    const translate = useTranslate('notificationPermissionDialog');
    const closeDialog = useCallback(() => {
        onTrack(TRACK_EVENTS.NOTIFICATION_PUSH_CLOSE, data);
        onClose();
    }, [data, onClose, onTrack]);
    const cancelDialog = useCallback(() => {
        onTrack(TRACK_EVENTS.NOTIFICATION_PUSH_CANCEL, data);
        onClose();
    }, [data, onClose, onTrack]);
    const showNativePermissionDialog = useCallback(() => {
        onTrack(TRACK_EVENTS.NOTIFICATION_PUSH_OPT_IN, data);
        onClose();
        onRegister({
            data,
            errorMessage: translate('registrationError'),
            successMessage: translate('registrationSuccess'),
        });
    }, [data, onClose, onRegister, onTrack]);
    return (React.createElement(TranslateScope, { path: "notificationPermissionDialog" },
        React.createElement(MessageDialog, { isShown: isShown, size: Size.L, closeDialog: closeDialog, graphic: React.createElement(NotificationPermissionIcon, null), title: React.createElement(Translate, { message: "title", params: { firstName } }), text: React.createElement(TextWrapper, null,
                React.createElement(Translate, { html: true, message: "text", params: { privacyLink: '/privacy' } })), positiveButtonText: React.createElement(Translate, { message: "ctaButton" }), positiveButtonProps: { onClick: showNativePermissionDialog }, negativeButtonText: React.createElement(Translate, { message: "cancelButton" }), negativeButtonProps: { onClick: cancelDialog } })));
}
export default PermissionDialog;
//# sourceMappingURL=PermissionDialog.js.map